import { render, staticRenderFns } from "./FellowCard.vue?vue&type=template&id=5c6dbafc&scoped=true&"
import script from "./FellowCard.vue?vue&type=script&lang=js&"
export * from "./FellowCard.vue?vue&type=script&lang=js&"
import style0 from "./FellowCard.vue?vue&type=style&index=0&id=5c6dbafc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6dbafc",
  null
  
)

export default component.exports